import type { UseIntl } from '../../../types';
import type { FieldErrorsTypes } from './types';

import messages from './messages';

interface Payload {
  email: string;
}

/**
 * Validates the form fields for the forgot password form.
 *
 * @param {Payload} payload - Object containing form fields to validate.
 * @param {UseIntl} intl - React Intl object for localization of error messages.
 * @returns {FieldErrorsTypes} An object containing field-specific error messages, if any.
 *
 * @example
 * const errors = validateFormFields({ email: 'invalid-email' }, intl);
 * // errors.email -> "Enter a valid email address"
 */
export const validateFormFields = (
  payload: Payload,
  intl: UseIntl,
): FieldErrorsTypes => {
  const { email = '' } = payload;
  const fieldErrors: FieldErrorsTypes = {};

  if (email?.trim()) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!emailRegex.test(email)) {
      fieldErrors.email = intl.formatMessage(messages.invalidEmail);
    }
  } else {
    fieldErrors.email = intl.formatMessage(messages.enterEmail);
  }

  return fieldErrors;
};
